import { ChangeEvent, forwardRef, useCallback } from "react";
import { TagText } from "./custom-input.styles";
import {
   CustomInputWrapper,
   Label,
   ErrorP,
   InputField,
   InputWrapper,
   Badge,
   InputDivWrapper,
} from "./custom-input.styles";
import { IInputProps } from "../input/i-input";

const CustomInput = forwardRef<HTMLInputElement, IInputProps>(
   (
      {
         id,
         name,
         type,
         label,
         required,
         value,
         error,
         fullWidth,
         className,
         onChange,
         defaultValue,
         startAdornment,
         endAdornment,
         tag,
         custom,
         customText,
         datatype,
         notAurl,
         isMobile,
         preventSpaces,
         ...remainingProps
      },
      ref
   ) => {
      const labelId = label ? `${id}-label` : undefined;
      const errorId = error ? `${id}-error-text` : undefined;

      const handleChange = useCallback(
         (event: ChangeEvent<HTMLInputElement>) => {
            if (preventSpaces) {
               event.target.value = event.target.value.replace(/\s/g, "");
               onChange?.(event);
            } else {
               onChange?.(event);
            }
         },
         [onChange]
      );

      return (
         <CustomInputWrapper className={className}>
            {label && (
               <Label id={labelId} htmlFor={id}>
                  {`${label}${required ? "*" : ""}`}
               </Label>
            )}

            <InputDivWrapper>
               <InputWrapper>
                  {custom ? null : <Badge>https://</Badge>}
                  <InputField
                     id={id}
                     ref={ref}
                     name={name}
                     type={type}
                     value={value}
                     required={required}
                     aria-invalid={!!error}
                     defaultValue={defaultValue}
                     aria-describedby={errorId}
                     onChange={handleChange}
                     error={error}
                     tag={tag}
                     startAdornment={startAdornment}
                     isMobile={isMobile}
                     {...remainingProps}
                  />
                  {notAurl ? null : <Badge>.metricks.io</Badge>}
                  {custom && <Badge>{customText}</Badge>}
               </InputWrapper>
            </InputDivWrapper>
            {tag && <TagText>{tag}</TagText>}
            {error && (
               <ErrorP
                  initial="pageInitial"
                  animate="pageAnimate"
                  exit="pageExit"
                  variants={{
                     pageInitial: {
                        opacity: 1,
                        x: 0,
                        y: -5,
                     },
                     pageAnimate: {
                        opacity: 1,
                        x: 0,
                        y: 0,
                     },
                     pageExit: {
                        opacity: 0,
                     },
                  }}
                  id={errorId}
               >
                  {error}
               </ErrorP>
            )}
         </CustomInputWrapper>
      );
   }
);

CustomInput.displayName = "input";

export { CustomInput };
